import { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Contenedor from "../../Utils/Visuales/Contenedor";
import EditButton from "../../Utils/Botones/EditButton";
import { getRequest } from "../../Utils/Funciones/requester";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import ReporteDictamenesForm from "../../components/ReporteDictamenes/form";
import { validateFormDictamenes } from "../../Utils/Funciones/validateFormDictamenes";
import moment from "moment";
import { ExportCSV } from "../../Utils/Excel";
import { CircleLoader } from "../../components/CircleLoader";

function ReporteDictamenes() {
  const { enqueueSnackbar } = useSnackbar();
  const { campusUser2: campusOptions, campusName } = useSelector(
    (state) => state
  );

  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      campus: campusOptions?.find((item) => item.label.includes(campusName)),
    }));
  }, [campusOptions, campusName]);

  const handleClick = async () => {
    const isValid = validateFormDictamenes(form, enqueueSnackbar);

    if (isValid) {
      try {
        setDisabledButton(true);
        setLoading(true);

        let { campus, ciclo, fechaInicio, fechaFin, escuela, direccion } = form;
        const baseFechasUrl = "/reportes/dictamenes/detalle-fechas";
        const baseUrl = `/reportes/dictamenes`;

        if (!fechaInicio || !fechaFin) {
          const paramsFecha = buildParams({
            campus,
            ciclo,
            escuela,
            direccion,
          });

          const urlFecha = `${baseFechasUrl}?${paramsFecha.toString()}`;
          const { d, s, m } = await getRequest(urlFecha);

          if (s === "OK") {
            fechaInicio = d.fecha_inicio;
            fechaFin = d.fecha_fin;
          } else {
            return enqueueSnackbar(m, {
              variant: "error",
              autoHideDuration: null,
            });
          }
        }

        const start = moment(fechaInicio);
        const end = moment(fechaFin);

        const datosAcumulados = [];
        let dataSemana;
        let statusSemana;
        let messageSemana;
        for (
          let current = start.clone();
          current.isSameOrBefore(end);
          current.add(7, "days")
        ) {
          const weekEnd = moment.min(current.clone().add(6, "days"), end);

          const params = buildParams({
            campus,
            ciclo,
            escuela,
            direccion,
            fechaInicio: current.format("YYYY-MM-DD"),
            fechaFin: weekEnd.format("YYYY-MM-DD"),
          });

          const url = `${baseUrl}?${params.toString()}`;
          ({
            d: dataSemana,
            s: statusSemana,
            m: messageSemana,
          } = await getRequest(url));

          if (
            statusSemana === "OK" ||
            messageSemana ===
              "No se encontraron resultados para los filtros proporcionados"
          )
            datosAcumulados.push(...dataSemana);
          else {
            return enqueueSnackbar(messageSemana, { variant: "error" });
          }
        }

        enqueueSnackbar(messageSemana, { variant: "success" });

        if (datosAcumulados.length === 0)
          return enqueueSnackbar(
            "No se encontraron resultados para los filtros proporcionados",
            { variant: "error" }
          );

        handleDownloadExcel(datosAcumulados);
      } finally {
        setDisabledButton(false);
        setLoading(false);
      }
    }
  };

  function buildParams({
    campus,
    ciclo,
    escuela,
    direccion,
    fechaInicio,
    fechaFin,
  }) {
    return new URLSearchParams({
      id_campus: campus?.value,
      ciclo,
      ...(escuela && { id_escuela: escuela?.id }),
      ...(direccion && { id_direccion: direccion?.value }),
      ...(fechaInicio && { fecha_inicio: fechaInicio }),
      ...(fechaFin && { fecha_fin: fechaFin }),
    }).toString();
  }

  const handleDownloadExcel = async (excelInfo) => {
    const fecha = moment().format("DD/MM/YYYY");
    const hora = moment().format("HH:mm:ss");
    ExportCSV(excelInfo, `Reporte_Dictámenes_${fecha}_${hora}`);
  };

  return (
    <>
      {loading && <CircleLoader />}
      <Contenedor title="Reportes / Dictámenes">
        <Grid container>
          <ReporteDictamenesForm
            setForm={setForm}
            form={form}
            campusOptions={campusOptions}
          />
          <Grid item xs={2}>
            <EditButton
              onClick={handleClick}
              disabled={disabledButton || loading}
              style={{ padding: "10px 25px", marginBottom: 10, width: 99 }}
            >
              Generar
            </EditButton>
          </Grid>
        </Grid>
      </Contenedor>
    </>
  );
}

export default ReporteDictamenes;
